import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, Table, Button } from 'reactstrap';

const ErrorBulkInviteMembers = ({
  isOpen,
  toggle,
  errorRows,
  totalRows,
  onProceed,
}) => {
  const { t, ready } = useTranslation(['members', 'global']);
  if (!ready) return null;
  return (
    <Modal
      style={{ maxWidth: '600px', minWidth: '600px' }}
      isOpen={isOpen}
      toggle={toggle}
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader className="justify-content-center mb--4">
        <h2> {t('members:errorBulkInviteModalTitle')} </h2>
      </ModalHeader>
      <ModalBody>
        <p>
          {t('members:errorBulkInviteModalMessage', {
            count: +totalRows - +errorRows.length,
            total: totalRows,
          })}
        </p>
        <p>
          <strong>{t('members:errorBulkInviteModalDescription')}</strong>
        </p>

        <div style={{ maxHeight: '200px', overflowY: 'scroll' }}>
          <Table bordered>
            <thead className="table-light">
              <tr>
                <th>{t('global:row')}</th>
                <th>{t('global:email')}</th>
                <th>{t('global:comment')}</th>
              </tr>
            </thead>
            <tbody>
              {errorRows.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.row}</td>
                  <td>{item.email}</td>
                  <td>{item.comment}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-between mt-4">
          <Button
            color="transparent"
            className={` d-block `}
            style={{
              border: '1px solid black',
              borderRadius: '30px',
            }}
            onClick={toggle}
          >
            {t('global:cancel')}
          </Button>
          <Button
            color="primary"
            onClick={async () => {
              await onProceed();
              toggle();
            }}
            disabled={errorRows.length === totalRows}
          >
            {t('global:proceed')}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ErrorBulkInviteMembers;
